import styles from "./Start.module.css";
import berufsfachschule from "./assets/berufsfachschule.png";

const Start = () => {
    return(
        <>
                  <div
                      className={styles.hero}
                      style={{ backgroundImage: `url(${berufsfachschule})` }}
                  >

                  </div>

        <main className="wrapper">
            <section className="wrapperContent">
                <div className={styles.text}>
                    <h1>Die Zweijährige Berufsfachschule (BFS)</h1>
                    <h3>Schwerpunkt Wirtschaft und Verwaltung</h3>
                    <p>Die zweijährige Berufsfachschule ist eine weiterführende Vollzeitschulform. Sie eröffnet besondere Chancen für Hauptschülerinnen und Hauptschüler und bietet die Möglichkeit, junge Menschen fachrichtungs- und schwerpunktbezogen zu motivieren und auf eine berufliche Ausbildung vorzubereiten. Der erfolgreiche Besuch mit bestandener Abschlussprüfung ist dem mittleren Abschluss gleichwertig. Ein Übergang in die zweijährige höhere Berufsfachschule, die Fachoberschule oder das Berufliche Gymnasium ist möglich.</p>
                </div>
            </section>
        </main>
        </>
    )

}
export default Start;